module.exports = __webpack_public_path__ + "img/logo.8c1c67a5.png";